{
  "nav": {
    "mainNavigation": "التنقل الرئيسي",
    "sectionSettings": "الإعدادات",
    "customers": "العملاء",
    "categories": "التصنيفات",
    "settings": "الإعدادات",
    "customerSettings": "إعدادات العملاء",
    "users": "المستخدمين",
    "groups": "المجموعات",
    "changeBranch": "تغيير الفرع",
    "systems": "الأنظمة",
    "toggleSidebarHint": "تبديل الشريط الجانبي"
  },
  "brand": "المسافر"
}
